import type { ReactNode } from "react";
import classNames from "classnames";
import "./ViewRangeButton.scss";
import { useTranslation } from "react-i18next";
import type { ScheduleRange } from "@/pages/human-resources/time-management/model/ScheduleRange.ts";
import { Link } from "react-router-dom";

interface Properties {
  range: ScheduleRange;
  selected: boolean;
  url: string | undefined;
  disabled: boolean;
}

export default function ViewRangeButton(props: Properties): ReactNode {
  const { t } = useTranslation("humanResources", {
    keyPrefix: "timeManagement",
  });

  return (
    <div
      className={classNames(
        "view-range-button",
        props.selected && "selected",
        props.disabled && "disabled",
      )}
    >
      {renderLink()}
    </div>
  );

  function renderLink(): ReactNode {
    const label = t(`initial.${props.range.toLowerCase()}`);
    if (props.disabled) return label;
    if (props.range === "WEEK") {
      return <a href={props.url}>{label}</a>;
    }
    return (
      <Link to={props.url ?? ""} viewTransition>
        {label}
      </Link>
    );
  }
}
